module.exports = __webpack_public_path__ + "static/media/ic_document_tramite.a99cad4b.svg";